import classes from "./index.module.css";
// import { useState } from "react";

export default function Footer(props) {
    // const [text, setText] = useState(0);
    return (
        <footer className={classes.footer}>
            <div>
                Made with ❤️ by Roshan Dash
            </div>
        </footer>
    );
}
